import iconOekaki from "@/assets/img/icon_oekaki.svg";

/**
 * お絵描きスレのサムネイル右上に表示する小さなバッジ
 * カタログなどのグリッド表示で使用
 */
export const OekakiBadge: React.FunctionComponent = () => {
  return (
    <span
      role="img"
      aria-label="お絵かき"
      className="absolute top-1 right-1 h-6 w-6 p-1 bg-badge rounded"
      title="お絵かき機能で描かれた画像"
    >
      <img src={iconOekaki} alt="" aria-hidden="true" className="w-4 h-4" />
    </span>
  );
};
